export default __webpack_public_path__ + "static/media/Agarwal.bfe8c93b.png";